module.exports = __webpack_public_path__ + "static/media/1017933.b44bca4d.png";